import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import CleanFilterButton from '../../../../components/filter/CleanFilterButton'
import FlexGrid, { FlexColumn } from '../../../../components/structure/FlexGrid'
import ListCounter from '../../../../components/helpers/ListCounter'
import SeparatorWrapper from '../../../../components/helpers/SeparatorWrapper'

const AssetsCounterBar = () => {
  return (
    <SeparatorWrapper weight={4}>
      <FlexGrid justify="flex-start">
        <FlexColumn flex={1}>
          <ListCounter client={placesClient} entity="assets" filterName="AssetFilter" fullText bold />
        </FlexColumn>

        <FlexColumn>
          <CleanFilterButton />
        </FlexColumn>
      </FlexGrid>
    </SeparatorWrapper>
  )
}

export default AssetsCounterBar
